import React from 'react';

/**
 * Popup de sessão expirada
 * Exibe um modal informando que a sessão expirou e redireciona para login ao clicar OK
 */
export default function SessionExpiredPopup({ show, onClose }) {
  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 99999
    }}>
      <div style={{
        background: 'white',
        borderRadius: 12,
        padding: 32,
        width: '90%',
        maxWidth: 400,
        textAlign: 'center',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>⏰</div>
        <h2 style={{ margin: '0 0 16px 0', color: '#d32f2f' }}>Sessão Expirada</h2>
        <p style={{ color: '#666', marginBottom: 24, fontSize: 15 }}>
          Sua sessão expirou por inatividade. Por favor, faça login novamente para continuar.
        </p>
        <button
          onClick={onClose}
          style={{
            padding: '14px 48px',
            fontSize: 16,
            background: 'rgb(235, 133, 0)',
            border: 'none',
            borderRadius: 8,
            color: 'white',
            cursor: 'pointer',
            fontWeight: 600
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
}
